module.exports = __webpack_public_path__ + "media/images/illustration_10-a01319be136aefb4a394cc4abacdc8d2.png";